/* PDP gallery controls: prev/next arrows, mobile dots, keyboard stepping.
   Loaded after global.js. Thumbnail clicks and touch-swipe are wired there;
   this file only adds the controls that were missing, and reuses the existing
   activate() path by proxying through the matching thumbnail. */
(function () {
  var gallery = document.querySelector("[data-gallery]");
  if (!gallery) return;
  var stage = gallery.querySelector("[data-stage]");
  if (!stage) return;
  var items = [].slice.call(gallery.querySelectorAll("[data-stage-item]"));
  if (items.length < 2) return;

  var style = document.createElement("style");
  style.textContent = [
    ".pdp__stage{position:relative}",
    ".pdp__stage-nav{position:absolute;top:50%;transform:translateY(-50%);z-index:4;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.82);color:#1a1a1a;align-items:center;justify-content:center;cursor:pointer;opacity:0;display:flex;transition:opacity .25s ease,background .25s ease}",
    ".pdp__stage-nav svg{width:19px;height:19px;display:block}",
    ".pdp__stage-nav--prev{left:14px}",
    ".pdp__stage-nav--next{right:14px}",
    ".pdp__stage:hover .pdp__stage-nav,.pdp__stage-nav:focus-visible{opacity:1}",
    ".pdp__stage-nav:hover{background:#fff}",
    ".pdp__stage-nav[hidden]{display:none}",
    ".pdp__stage-dots{position:absolute;left:0;right:0;bottom:14px;display:none;justify-content:center;gap:7px;z-index:4}",
    ".pdp__stage-dots button{width:7px;height:7px;padding:0;border:0;border-radius:50%;background:rgba(26,26,26,.3);cursor:pointer;transition:background .2s ease}",
    ".pdp__stage-dots button.is-active{background:#1a1a1a}",
    "@media (max-width:900px){.pdp__stage-nav{opacity:1;width:38px;height:38px;background:rgba(255,255,255,.9)}.pdp__stage-nav--prev{left:8px}.pdp__stage-nav--next{right:8px}.pdp__stage-dots{display:flex}}"
  ].join("");
  document.head.appendChild(style);

  function arrow(dir, label, points) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "pdp__stage-nav pdp__stage-nav--" + dir;
    b.setAttribute("aria-label", label);
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + points + '"/></svg>';
    return b;
  }
  var prev = arrow("prev", "Previous image", "15 5 8 12 15 19");
  var next = arrow("next", "Next image", "9 5 16 12 9 19");
  var dots = document.createElement("div");
  dots.className = "pdp__stage-dots";
  stage.appendChild(prev);
  stage.appendChild(next);
  stage.appendChild(dots);

  function visible() {
    var model = gallery.getAttribute("data-active-model") || "1";
    var vis = items.filter(function (it) { return it.getAttribute("data-model-group") === model; });
    return vis.length ? vis : items;
  }
  function currentIndex(vis) {
    for (var i = 0; i < vis.length; i++) { if (vis[i].classList.contains("is-active")) return i; }
    return 0;
  }
  function show(el) {
    var idx = el.getAttribute("data-index");
    var thumb = gallery.querySelector('[data-thumb-btn][data-thumb-index="' + idx + '"]');
    if (thumb) { thumb.click(); return; }
    items.forEach(function (it) { it.classList.toggle("is-active", it === el); });
    sync();
  }
  function step(dir) {
    var vis = visible();
    if (vis.length < 2) return;
    show(vis[(currentIndex(vis) + dir + vis.length) % vis.length]);
  }
  function sync() {
    var vis = visible();
    var many = vis.length > 1;
    if (prev.hidden !== !many) prev.hidden = !many;
    if (next.hidden !== !many) next.hidden = !many;
    dots.innerHTML = "";
    if (!many) return;
    var cur = currentIndex(vis);
    vis.forEach(function (it, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "View image " + (i + 1));
      if (i === cur) b.className = "is-active";
      b.addEventListener("click", function () { show(it); });
      dots.appendChild(b);
    });
  }

  prev.addEventListener("click", function (e) { e.preventDefault(); step(-1); });
  next.addEventListener("click", function (e) { e.preventDefault(); step(1); });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target || {};
    var tag = (t.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select" || t.isContentEditable) return;
    var r = gallery.getBoundingClientRect();
    if (r.bottom < 40 || r.top > (window.innerHeight || 0) - 40) return;
    e.preventDefault();
    step(e.key === "ArrowRight" ? 1 : -1);
  });

  items.forEach(function (it) {
    new MutationObserver(sync).observe(it, { attributes: true, attributeFilter: ["class"] });
  });
  gallery.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-model-btn]")) setTimeout(sync, 0);
  });

  sync();
})();
